import { render, staticRenderFns } from "./rich-text.vue?vue&type=template&id=d688f6dc&scoped=true"
import script from "./rich-text.vue?vue&type=script&lang=js"
export * from "./rich-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d688f6dc",
  null
  
)

export default component.exports